module.exports = __webpack_public_path__ + "img/sign-38.83c69847.jpg";